import { gql } from '@apollo/client'

// ==========================================
// AUTH
// ==========================================

export const LOGIN = gql`
  mutation Login($usuario: String!, $password: String!) {
    login(usuario: $usuario, password: $password) {
      token
      usuario {
        id
        nombre
        usuario
        rol
        email
      }
    }
  }
`

export const ME = gql`
  query Me {
    me {
      id
      nombre
      usuario
      rol
      email
    }
  }
`

// ==========================================
// DASHBOARD
// ==========================================

export const GET_ESTADISTICAS = gql`
  query GetEstadisticas {
    estadisticas {
      total_comercios
      comercios_activos
      comercios_pendientes
      comercios_suspendidos
      licencias_activas
      licencias_por_vencer
      licencias_vencidas
      solicitudes_pendientes
    }
  }
`

export const GET_ALERTAS_VENCIMIENTO = gql`
  query GetAlertasVencimiento($dias: Int) {
    alertasVencimiento(dias: $dias) {
      licencia_id
      comercio_id
      nit
      nombre_comercial
      email
      telefono
      tipo_licencia
      fecha_vencimiento
      dias_restantes
      nivel_alerta
    }
  }
`

// ==========================================
// COMERCIOS
// ==========================================

export const GET_COMERCIOS = gql`
  query GetComercios($busqueda: String, $estado: String, $tipo_interfaz: String, $limit: Int, $offset: Int) {
    comercios(busqueda: $busqueda, estado: $estado, tipo_interfaz: $tipo_interfaz, limit: $limit, offset: $offset) {
      id
      nit
      nombre_comercial
      razon_social
      ciudad
      tipo_interfaz
      estado
      email
      telefono
      created_at
      licencia_activa {
        id
        tipo_licencia
        tipo_licencia_nombre
        fecha_vencimiento
        dias_restantes
        estado
      }
    }
    totalComercios(busqueda: $busqueda, estado: $estado, tipo_interfaz: $tipo_interfaz)
  }
`

export const GET_COMERCIO = gql`
  query GetComercio($id: ID!) {
    comercio(id: $id) {
      id
      nit
      nombre_comercial
      razon_social
      direccion
      ciudad
      departamento
      telefono
      email
      representante_legal
      tipo_interfaz
      estado
      notas
      created_at
      updated_at
      licencia_activa {
        id
        codigo_licencia
        tipo_licencia
        tipo_licencia_nombre
        fecha_emision
        fecha_activacion
        fecha_vencimiento
        dias_restantes
        en_gracia
        estado
        modulos {
          codigo
          nombre
          descripcion
          categoria
          es_core
        }
        modulos_codigos
      }
      licencias {
        id
        codigo_licencia
        tipo_licencia
        tipo_licencia_nombre
        fecha_emision
        fecha_vencimiento
        dias_restantes
        estado
      }
      historial {
        id
        accion
        descripcion
        created_at
        usuario {
          nombre
        }
      }
    }
  }
`

export const CREAR_COMERCIO = gql`
  mutation CrearComercio($input: ComercioInput!) {
    crearComercio(input: $input) {
      id
      nit
      nombre_comercial
    }
  }
`

export const ACTUALIZAR_COMERCIO = gql`
  mutation ActualizarComercio($id: ID!, $input: ComercioInput!) {
    actualizarComercio(id: $id, input: $input) {
      id
      nit
      nombre_comercial
    }
  }
`

export const SUSPENDER_COMERCIO = gql`
  mutation SuspenderComercio($id: ID!, $motivo: String) {
    suspenderComercio(id: $id, motivo: $motivo) {
      id
      estado
    }
  }
`

export const REACTIVAR_COMERCIO = gql`
  mutation ReactivarComercio($id: ID!) {
    reactivarComercio(id: $id) {
      id
      estado
    }
  }
`

// ==========================================
// SOLICITUDES
// ==========================================

export const GET_SOLICITUDES = gql`
  query GetSolicitudes($estado: String, $tipo_interfaz: String, $limit: Int, $offset: Int) {
    solicitudes(estado: $estado, tipo_interfaz: $tipo_interfaz, limit: $limit, offset: $offset) {
      id
      nit
      nombre_comercial
      razon_social
      email
      telefono
      ciudad
      tipo_interfaz
      tipo_licencia
      tipo_licencia_nombre
      estado
      created_at
      fecha_procesamiento
      motivo_rechazo
      procesador {
        nombre
      }
    }
    totalSolicitudes(estado: $estado, tipo_interfaz: $tipo_interfaz)
  }
`

export const GET_SOLICITUDES_PENDIENTES = gql`
  query GetSolicitudesPendientes {
    solicitudesPendientes {
      id
      nit
      nombre_comercial
      razon_social
      email
      telefono
      ciudad
      tipo_interfaz
      tipo_licencia
      tipo_licencia_nombre
      created_at
    }
  }
`

export const APROBAR_SOLICITUD = gql`
  mutation AprobarSolicitud($id: ID!, $fecha_vencimiento: String) {
    aprobarSolicitud(id: $id, fecha_vencimiento: $fecha_vencimiento) {
      licencia {
        id
        codigo_licencia
        tipo_licencia
        fecha_vencimiento
      }
      codigo
      email_enviado
    }
  }
`

export const RECHAZAR_SOLICITUD = gql`
  mutation RechazarSolicitud($id: ID!, $motivo: String!) {
    rechazarSolicitud(id: $id, motivo: $motivo) {
      id
      estado
    }
  }
`

// ==========================================
// LICENCIAS
// ==========================================

export const GENERAR_LICENCIA = gql`
  mutation GenerarLicencia($input: GenerarLicenciaInput!) {
    generarLicencia(input: $input) {
      licencia {
        id
        codigo_licencia
        tipo_licencia
        fecha_vencimiento
      }
      codigo
      email_enviado
    }
  }
`

export const RENOVAR_LICENCIA = gql`
  mutation RenovarLicencia($licencia_id: ID!, $tipo_licencia: String!, $fecha_vencimiento: String) {
    renovarLicencia(licencia_id: $licencia_id, tipo_licencia: $tipo_licencia, fecha_vencimiento: $fecha_vencimiento) {
      licencia {
        id
        codigo_licencia
        tipo_licencia
        fecha_vencimiento
      }
      codigo
      email_enviado
    }
  }
`

export const SUSPENDER_LICENCIA = gql`
  mutation SuspenderLicencia($id: ID!, $motivo: String) {
    suspenderLicencia(id: $id, motivo: $motivo) {
      id
      estado
    }
  }
`

// ==========================================
// CONFIGURACIÓN
// ==========================================

export const GET_CONFIGURACION = gql`
  query GetConfiguracion {
    configuracionGestor {
      id
      dias_gracia_default
      dias_alerta_vencimiento
      email_notificaciones
      nombre_sistema
    }
  }
`

export const ACTUALIZAR_CONFIGURACION = gql`
  mutation ActualizarConfiguracion(
    $dias_gracia_default: Int
    $dias_alerta_vencimiento: Int
    $email_notificaciones: String
    $nombre_sistema: String
  ) {
    actualizarConfiguracionGestor(
      dias_gracia_default: $dias_gracia_default
      dias_alerta_vencimiento: $dias_alerta_vencimiento
      email_notificaciones: $email_notificaciones
      nombre_sistema: $nombre_sistema
    ) {
      id
      dias_gracia_default
      dias_alerta_vencimiento
      email_notificaciones
      nombre_sistema
    }
  }
`

// ==========================================
// MODULOS
// ==========================================

export const GET_MODULOS = gql`
  query GetModulos($soloActivos: Boolean, $categoria: String, $tipoInterfaz: String) {
    modulos(soloActivos: $soloActivos, categoria: $categoria, tipoInterfaz: $tipoInterfaz) {
      id
      codigo
      nombre
      descripcion
      icono
      categoria
      es_core
      tipo_interfaz
      requiere_modulos
      orden_menu
      ruta_base
      activo
    }
  }
`

export const GET_MODULOS_LICENCIA = gql`
  query GetModulosLicencia($licenciaId: ID!) {
    modulosLicencia(licenciaId: $licenciaId) {
      id
      codigo
      nombre
      descripcion
      categoria
      es_core
      tipo_interfaz
    }
  }
`

export const GET_PLANES = gql`
  query GetPlanes($soloActivos: Boolean) {
    planes(soloActivos: $soloActivos) {
      id
      codigo
      nombre
      descripcion
      precio_mensual
      precio_anual
      modulos_incluidos
      caracteristicas
      destacado
      orden
      activo
      modulos {
        codigo
        nombre
        es_core
      }
    }
  }
`

export const ASIGNAR_MODULOS_LICENCIA = gql`
  mutation AsignarModulosLicencia($licenciaId: ID!, $modulosCodigos: [String!]!) {
    asignarModulosLicencia(licenciaId: $licenciaId, modulosCodigos: $modulosCodigos) {
      id
      modulos {
        codigo
        nombre
        es_core
      }
      modulos_codigos
    }
  }
`

export const AGREGAR_MODULO_LICENCIA = gql`
  mutation AgregarModuloLicencia($licenciaId: ID!, $moduloCodigo: String!) {
    agregarModuloLicencia(licenciaId: $licenciaId, moduloCodigo: $moduloCodigo) {
      id
      modulos_codigos
    }
  }
`

export const REMOVER_MODULO_LICENCIA = gql`
  mutation RemoverModuloLicencia($licenciaId: ID!, $moduloCodigo: String!) {
    removerModuloLicencia(licenciaId: $licenciaId, moduloCodigo: $moduloCodigo) {
      id
      modulos_codigos
    }
  }
`
